import DashboardLayout from '../layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'

// Admin pages
import Overview from 'src/pages/Overview.vue'
import UserProfile from 'src/pages/UserProfile.vue'
import TableList from 'src/pages/TableList.vue'
import Typography from 'src/pages/Typography.vue'
import Icons from 'src/pages/Icons.vue'
import Maps from 'src/pages/Maps.vue'
import Notifications from 'src/pages/Notifications.vue'
import Upgrade from 'src/pages/Upgrade.vue'
import Login from '../pages/Login.vue'
import Schedule from '../pages/Schedule.vue'
import Raspisaniya from '../pages/Raspisaniya.vue'
import Logout from '../pages/Logout.vue'
import SubjectCrud from '../pages/SubjectCrud.vue'
import TutorCrud from '../pages/TutorCrud.vue'
import UserCrud from '../pages/UserCrud.vue'
import GroupCrud from '../pages/GroupCrud.vue'
import ScheduleCrud from '../pages/ScheduleCrud.vue'
import TutorRaspisaniya from "@/pages/TutorRaspisaniya.vue";
import CreateSchedule from "@/pages/CreateSchedule.vue";
import SemesterCrud from "@/pages/SemesterCrud.vue";

const routes = [
  // --- USER / GENERAL ROUTES ---
  // This block uses DashboardLayout but starts at the root '/'
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/schedule', // Default redirect
    children: [
      {
        path: 'schedule', // URL will be: domain.com/schedule
        name: 'Schedule',
        component: Schedule,
        meta: { title: 'Расписание НИЯУ МИФИ Ташкент' }
      },
      // I moved this here too, so the URL is /study-groups/... instead of /admin/study-groups/...
      {
        path: 'study-groups/:id/day',
        name: 'Study groups',
        component: Raspisaniya
      },
      {
        path: 'tutor-schedule/:id',
        name: 'Tutor Schedule',
        component: TutorRaspisaniya
      }
    ]
  },

  // --- AUTH ROUTES ---
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout
  },

  // --- ADMIN ROUTES ---
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/table-list',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
      {
        path: 'user',
        name: 'User',
        component: UserProfile
      },
      {
        path: 'semesters',
        name: 'Semesters',
        component: SemesterCrud
      },
      {
        path: 'table-list',
        name: 'Table List',
        component: TableList
      },
      // REMOVED Schedule and Raspisaniya from here
      {
        path: 'create-subject',
        name: 'Create Subject',
        component: SubjectCrud,
      },
      {
        path: 'create-tutor',
        name: 'Create Tutor',
        component: TutorCrud,
      },
      {
        path: 'manage-schedule',
        name: 'Managa Schedule',
        component: ScheduleCrud
      },
      {
        path: 'create-schedule',
        name: 'Create Schedule',
        component: CreateSchedule,
      },
      {
        path: 'create-group',
        name: 'Create Group',
        component: GroupCrud,
      },
      {
        path: 'create-user',
        name: 'Create User',
        component: UserCrud,
      },
      {
        path: 'typography',
        name: 'Typography',
        component: Typography
      },
      {
        path: 'icons',
        name: 'Icons',
        component: Icons
      },
      {
        path: 'maps',
        name: 'Maps',
        component: Maps
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: Notifications
      },
      {
        path: 'upgrade',
        name: 'Upgrade to PRO',
        component: Upgrade
      }
    ]
  },
  { path: '*', component: NotFound }
]

export default routes
